import React from 'react';
import './EditPostButton.css';
import { ReactComponent as EditPostIcon } from './edit-post-icon.svg';

export const EditPostButton = ({ onEditPost }) => {
    return (
        <div
            className="decline edit-post-button d-flex justify-content-center align-items-center"
            onClick={() => onEditPost()}
        >
            <EditPostIcon />
        </div>
    );
};
